import { useState } from "react";
import { Col, Row, Image, Button } from "react-bootstrap";
import loadingLogo from "../assets/loading-logo.png";

const StoreDetails = ({ store }) => {
  const [isLogoLoading, setIsLogoLoading] = useState(true);

  return (
    <Row>
      <Col xs={6} sm={4} md={3} lg={2} xl={2}>
        <Image
          src={loadingLogo}
          rounded
          className="mw-100 border"
          alt={`${store.nameEn} logo`}
          style={{ display: isLogoLoading ? "inline" : "none" }}
        />

        <Image
          src={store.logo}
          rounded
          className="mw-100 border"
          alt={`${store.nameEn} logo`}
          style={{ display: isLogoLoading ? "none" : "inline" }}
          onLoad={() => setIsLogoLoading(false)}
        />
      </Col>
      <Col
        xs={6}
        sm={4}
        md={3}
        lg={2}
        xl={2}
        className="d-flex flex-column justify-content-around align-items-start text-right"
      >
        <h1 className="h3">
          {store.nameAr} {store.nameEn}
        </h1>
        <Button variant="info" target="_blank" href={store.link}>
          زيارة المتجر
        </Button>
      </Col>
    </Row>
  );
};

export default StoreDetails;
